import api from '../_api'
import { service as bilingPrimary } from '@/api/billing-primary'
import {
    FETCH_INOVICE_MONTHS_REQUEST,
    FETCH_INOVICE_MONTHS_SUCCESS,
    FETCH_INOVICE_MONTHS_FAILED,
    FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST,
    FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS,
    FETCH_INVOICE_ANNUAL_SUMMARY_FAILED,
    DOWNLOAD_INVOICE_PDF_REQUEST,
    DOWNLOAD_INVOICE_PDF_SUCCESS,
    DOWNLOAD_INVOICE_PDF_FAILED
} from './mutation-type'

const getInvoiceMonths = async ({ commit, state, getters, rootGetters }, { usageAccountId }) => {
    commit(FETCH_INOVICE_MONTHS_REQUEST)
    try {
        const { status, data } = await api.fetchInvoiceMonths({ usageAccountId }, rootGetters.requiredService)
        commit(FETCH_INOVICE_MONTHS_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_INOVICE_MONTHS_FAILED, error)
        throw error
    }
}

const getInvoiceAnnualSummary = async ({ commit, state, getters, rootGetters }, { usageAccountId, year }) => {
    commit(FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST)
    try {
        const { status, data } = await api.fetchInvoiceAnnualSummary({ usageAccountId, year }, rootGetters.requiredService)
        commit(FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_INVOICE_ANNUAL_SUMMARY_FAILED, error)
        throw error
    }
}

const downloadInvoicePDF = async ({ commit, state, getters, rootGetters }, { usageAccountId, month, locale }) => {
    commit(DOWNLOAD_INVOICE_PDF_REQUEST)
    try {
        const { data } = await bilingPrimary.invoicePDF({ usageAccountId, month, locale }, rootGetters.requiredService)
        commit(DOWNLOAD_INVOICE_PDF_SUCCESS, data)
        return data
    } catch (error) {
        commit(DOWNLOAD_INVOICE_PDF_FAILED)
        throw error
    }
}

export default {
    getInvoiceMonths,
    getInvoiceAnnualSummary,
    downloadInvoicePDF
}
